import { render, staticRenderFns } from "./TutorialSumoRing.vue?vue&type=template&id=3e365169&scoped=true&"
var script = {}
import style0 from "./TutorialSumoRing.vue?vue&type=style&index=0&id=3e365169&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e365169",
  null
  
)

component.options.__file = "TutorialSumoRing.vue"
export default component.exports